
















import Vue from 'vue'

import { store } from 'base/store'
import { MessageChannel } from 'base/store/state.interface'

import ChannelListPanel from './channel/list/ChannelListPanel.vue'
import MessengerDragDropLayout from './drag-drop/MessengerDragDropLayout.vue'
import { ChatLayout } from './layout/chat-layout.interface'
import { chatLayouts } from './layout/chat-layouts'
import LayoutPanel from './layout/LayoutPanel.vue'
import { ApiRequestService, ApiUrls } from '../base/services'

export default Vue.extend({
  components: {
    ChannelListPanel,
    MessengerDragDropLayout,
    LayoutPanel
  },
  data() {
    return {
      layouts: chatLayouts,
      favoritedChannelIds: [] as number[]
    }
  },
  computed: {
    selectedChannelId() {
      return this.$store.state.messenger.layout.selectedChannelId
    },
    selectedLayoutIndex() {
      return this.$store.state.messenger.layout.selectedLayoutIndex
    },
    channels(): MessageChannel[] {
      if (!store.state.message_channel) return []

      return Object.values(store.state.message_channel.items)
    },
    selectedLayout(): ChatLayout {
      if (this.selectedLayoutIndex === null) {
        return this.layouts[0]
      }

      return this.layouts[this.selectedLayoutIndex]
    },
    selectedChannel(): MessageChannel | undefined {
      if (this.channels.length === 0) return

      // Fallback to first channel if none is selected
      if (!this.selectedChannelId) {
        // assigning variable to satisfy ts-lint
        const p = this.channelSelected(this.channels[0].id)
        return this.channels[0]
      }

      return store.state.message_channel.items[this.selectedChannelId.toString()]
    },
    favoritedChannels(): MessageChannel[] {
      if (!store.state.message_channel) return []

      return this.favoritedChannelIds.map(channelId => store.state.message_channel.items[channelId.toString()])
              .filter(channel => channel !== undefined) // Prevent deleted channels to be provided
    }
  },
  methods: {
    async addChannelToCollection(channel: MessageChannel, columnIndex: number) {
      const columns = this.$store.state.messenger.layout.channelCollection
      const indexInColumn = columns[columnIndex] ? columns[columnIndex].length : 0

      // Prevent clones of selected channel in primary column
      if (this.selectedChannel && channel.id === this.selectedChannel.id && this.selectedLayout.columns[columnIndex].isPrimary) {
        return
      }

      await this.$store.dispatch('moveChannelToColumn', {
        channel: channel,
        columnId: columnIndex,
        indexInColumn: indexInColumn
      })
    },
    async channelSelected(channelId: number) {
      if (channelId === this.$store.state.messenger.layout.selectedChannelId) return

      void this.$store.dispatch('setSelectedChannelId', channelId)
    },
    channelFavouriteToggled(channelId: number) {
      if (!this.favoritedChannelIds.includes(channelId)) {
        this.favoritedChannelIds.push(channelId)
        return
      }

      this.favoritedChannelIds = this.favoritedChannelIds.filter(favChannelId => favChannelId !== channelId)
    },
    async layoutSelected(index: number) {
      void this.$store.dispatch('setSelectedLayoutIndex', index)
    }
  }
})
